export default {
  welcome: {
    en: "Welcome!",
    ja: "ようこそ！"
  }
}
